module.exports = new __parcel__URL__("tabs_zh-cn.7f2d5508.webp").toString();